// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_format from "../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as EventTracker from "../../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as FormTextArea from "../../../../../../library/components/generic-components/components/FormTextArea.bs.js";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as ProgressModal from "../../../../../../library/components/generic-components/components/ProgressModal.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as EditOrderDataMachine from "../../../app/repo/EditOrderDataMachine.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as SubmitModalConfirmation from "../sidebars/SubmitModalConfirmation.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SecondaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/SecondaryButton.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as FormRadioGroupInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormRadioGroupInput.bs.js";

function isCancelOrderFormActive(orderStatus) {
  return orderStatus !== 8;
}

var validators_additionalComment = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var additionalComment = param.additionalComment;
      if (additionalComment === "") {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: additionalComment
              };
      }
    })
};

var validators_cancelledReason = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var cancelledReason = param.cancelledReason;
      if (cancelledReason !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: cancelledReason.key
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please select cancellation reason"
              };
      }
    })
};

var validators_cancelledBy = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var cancelledBy = param.cancelledBy;
      if (cancelledBy === "") {
        return {
                TAG: /* Error */1,
                _0: "Please select who wants to cancel this order"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: cancelledBy
              };
      }
    })
};

var validators = {
  additionalComment: validators_additionalComment,
  cancelledReason: validators_cancelledReason,
  cancelledBy: validators_cancelledBy
};

function initialFieldsStatuses(_input) {
  return {
          additionalComment: /* Pristine */0,
          cancelledReason: /* Pristine */0,
          cancelledBy: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            additionalComment: /* Pristine */0,
            cancelledReason: /* Pristine */0,
            cancelledBy: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.additionalComment;
  var match_0 = match ? match._0 : Curry._1(validators.additionalComment.validate, input);
  var match$1 = fieldsStatuses.cancelledReason;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.cancelledReason.validate, input);
  var match$2 = fieldsStatuses.cancelledBy;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.cancelledBy.validate, input);
  var additionalCommentResult = match_0;
  var additionalCommentResult$1;
  if (additionalCommentResult.TAG === /* Ok */0) {
    var cancelledReasonResult = match_0$1;
    if (cancelledReasonResult.TAG === /* Ok */0) {
      var cancelledByResult = match_0$2;
      if (cancelledByResult.TAG === /* Ok */0) {
        return {
                TAG: /* Valid */0,
                output: {
                  cancelledBy: cancelledByResult._0,
                  cancelledReason: cancelledReasonResult._0,
                  additionalComment: additionalCommentResult._0
                },
                fieldsStatuses: {
                  additionalComment: /* Dirty */{
                    _0: additionalCommentResult,
                    _1: /* Shown */0
                  },
                  cancelledReason: /* Dirty */{
                    _0: cancelledReasonResult,
                    _1: /* Shown */0
                  },
                  cancelledBy: /* Dirty */{
                    _0: cancelledByResult,
                    _1: /* Shown */0
                  }
                },
                collectionsStatuses: undefined
              };
      }
      additionalCommentResult$1 = additionalCommentResult;
    } else {
      additionalCommentResult$1 = additionalCommentResult;
    }
  } else {
    additionalCommentResult$1 = additionalCommentResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            additionalComment: /* Dirty */{
              _0: additionalCommentResult$1,
              _1: /* Shown */0
            },
            cancelledReason: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            cancelledBy: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurAdditionalCommentField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.additionalComment, validators_additionalComment, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  additionalComment: status,
                                  cancelledReason: init.cancelledReason,
                                  cancelledBy: init.cancelledBy
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCancelledReasonField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.cancelledReason, validators_cancelledReason, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  additionalComment: init.additionalComment,
                                  cancelledReason: status,
                                  cancelledBy: init.cancelledBy
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCancelledByField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.cancelledBy, validators_cancelledBy, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  additionalComment: init.additionalComment,
                                  cancelledReason: init.cancelledReason,
                                  cancelledBy: status
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */3 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */3,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */4,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */6);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */5);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */4 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */5 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */6 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateAdditionalCommentField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.additionalComment, state.submissionStatus, validators_additionalComment, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            additionalComment: status,
                                            cancelledReason: init.cancelledReason,
                                            cancelledBy: init.cancelledBy
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCancelledReasonField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.cancelledReason, state.submissionStatus, validators_cancelledReason, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            additionalComment: init.additionalComment,
                                            cancelledReason: status,
                                            cancelledBy: init.cancelledBy
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCancelledByField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$3 = Formality.validateDependentFieldOnChange(nextInput$2, nextFieldsStatuses.contents.cancelledReason, validators_cancelledReason, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  additionalComment: init.additionalComment,
                                  cancelledReason: status,
                                  cancelledBy: init.cancelledBy
                                };
                        }));
                  if (result$3 !== undefined) {
                    nextFieldsStatuses.contents = result$3;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, nextFieldsStatuses.contents.cancelledBy, state.submissionStatus, validators_cancelledBy, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            additionalComment: init.additionalComment,
                                            cancelledReason: init.cancelledReason,
                                            cancelledBy: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */3 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                additionalComment: /* Pristine */0,
                                cancelledReason: /* Pristine */0,
                                cancelledBy: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                additionalComment: /* Pristine */0,
                                cancelledReason: /* Pristine */0,
                                cancelledBy: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */4 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */5 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateAdditionalComment: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAdditionalCommentField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCancelledReason: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCancelledReasonField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCancelledBy: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCancelledByField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurAdditionalComment: (function (param) {
              return Curry._1(dispatch, /* BlurAdditionalCommentField */0);
            }),
          blurCancelledReason: (function (param) {
              return Curry._1(dispatch, /* BlurCancelledReasonField */1);
            }),
          blurCancelledBy: (function (param) {
              return Curry._1(dispatch, /* BlurCancelledByField */2);
            }),
          additionalCommentResult: Formality.exposeFieldResult(state.fieldsStatuses.additionalComment),
          cancelledReasonResult: Formality.exposeFieldResult(state.fieldsStatuses.cancelledReason),
          cancelledByResult: Formality.exposeFieldResult(state.fieldsStatuses.cancelledBy),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.additionalComment || match.cancelledReason || match.cancelledBy) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */3);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */4);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */5);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */5,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */6);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function makeSelectComponentList(data) {
  return List.map((function (reason) {
                return {
                        key: reason.key,
                        value: reason.value,
                        text: reason.text
                      };
              }), data);
}

function getSelectItemDynamically(cancelledBy, cancellationReasons) {
  if (cancelledBy === undefined) {
    return makeSelectComponentList(cancellationReasons.customer_reasons);
  }
  if (cancelledBy.TAG !== /* Ok */0) {
    return /* [] */0;
  }
  var data = cancelledBy._0;
  if (data === "Customer") {
    return makeSelectComponentList(cancellationReasons.customer_reasons);
  } else if (data === "Partner") {
    return makeSelectComponentList(cancellationReasons.partner_reasons);
  } else if (data === "Allocation") {
    return makeSelectComponentList(cancellationReasons.allocation_reasons);
  } else {
    return /* [] */0;
  }
}

function CancelOrderForm(Props) {
  var cancellationReasons = Props.cancellationReasons;
  var toggleEditOrderSidebar = Props.toggleEditOrderSidebar;
  var changeDiscardModalState = Props.changeDiscardModalState;
  var openSnackbar = Props.openSnackbar;
  var orderId = Props.orderId;
  var order_updated_at = Props.order_updated_at;
  var orderStatus = Props.orderStatus;
  var match = React.useState(function () {
        return false;
      });
  var toggleSaveModal = match[1];
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  var match$2 = React.useState(function () {
        return false;
      });
  var setSubmittingModal = match$2[1];
  var form = useForm({
        cancelledBy: "Customer",
        cancelledReason: undefined,
        additionalComment: ""
      }, (function (output, _form) {
          Curry._1(setSubmittingModal, (function (param) {
                  return true;
                }));
          var payload_cancelled_by = output.cancelledBy;
          var payload_cancel_reason_id = Caml_format.caml_int_of_string(output.cancelledReason);
          var payload_comment = output.additionalComment;
          var payload = {
            crn: orderId,
            cancelled_by: payload_cancelled_by,
            cancel_reason_id: payload_cancel_reason_id,
            order_updated_at: order_updated_at,
            comment: payload_comment
          };
          return EditOrderDataMachine.cancelOrder(payload, (function (_data) {
                        Curry._1(toggleEditOrderSidebar, undefined);
                        Curry._1(changeDiscardModalState, (function (param) {
                                return false;
                              }));
                        Curry._1(setSubmittingModal, (function (param) {
                                return false;
                              }));
                        Curry._1(openSnackbar, {
                              TAG: /* Success */0,
                              _0: "Order Updated Successfully"
                            });
                        return EventTracker.publishEvent({
                                    category: "Edit Order GA4",
                                    action: "New Edit Order submit Successful",
                                    label: "Cancel Order",
                                    value: undefined,
                                    nonInteraction: undefined
                                  });
                      }), (function (error) {
                        Curry._1(openSnackbar, {
                              TAG: /* Error */1,
                              _0: ErrorUtils$Catalyst.resolveError(error)
                            });
                        EventTracker.publishEvent({
                              category: "Edit Order GA4",
                              action: "New Edit Order submit Failure",
                              label: "Cancel Order",
                              value: undefined,
                              nonInteraction: undefined
                            });
                        return Curry._1(setSubmittingModal, (function (param) {
                                      return false;
                                    }));
                      }), country);
        }));
  var match$3 = form.status;
  var tmp;
  var exit = 0;
  if (typeof match$3 === "number") {
    if (match$3 === /* Editing */0) {
      exit = 1;
    } else {
      Curry._1(toggleEditOrderSidebar, undefined);
      Curry._1(changeDiscardModalState, (function (param) {
              return false;
            }));
      tmp = null;
    }
  } else if (match$3.TAG === /* Submitting */0) {
    tmp = null;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = React.createElement(SubmitModalConfirmation.make, {
          isOpen: match[0],
          onCancel: (function (param) {
              return Curry._1(toggleSaveModal, (function (param) {
                            return false;
                          }));
            }),
          onSubmit: (function (param) {
              Curry._1(toggleSaveModal, (function (param) {
                      return false;
                    }));
              return Curry._1(form.submit, undefined);
            })
        });
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", undefined, React.createElement("form", {
                      className: "cancel-form",
                      onSubmit: (function ($$event) {
                          $$event.preventDefault();
                          return Curry._1(form.submit, undefined);
                        })
                    }, React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("label", undefined, "Cancelled By"), React.createElement(FormRadioGroupInput$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                            return Curry._2(form.updateCancelledBy, (function (input, value) {
                                                          return {
                                                                  cancelledBy: value,
                                                                  cancelledReason: undefined,
                                                                  additionalComment: input.additionalComment
                                                                };
                                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                          }), orderStatus === 8, undefined, undefined, undefined, undefined, undefined, form.cancelledByResult, undefined, "order-cancelled-by", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    radio_props: {
                                      options: {
                                        hd: {
                                          label: "Customer",
                                          value: "Customer"
                                        },
                                        tl: {
                                          hd: {
                                            label: "Partner",
                                            value: "Partner"
                                          },
                                          tl: {
                                            hd: {
                                              label: "Allocation",
                                              value: "Allocation"
                                            },
                                            tl: /* [] */0
                                          }
                                        }
                                      },
                                      value: form.input.cancelledBy,
                                      row_layout: true
                                    }
                                  }))
                        }), React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("div", undefined, React.createElement("label", undefined, "Reason"), React.createElement(FormSelectInput$Catalyst.make, {
                                        input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                                return Curry._2(form.updateCancelledReason, (function (input, value) {
                                                              return {
                                                                      cancelledBy: input.cancelledBy,
                                                                      cancelledReason: value,
                                                                      additionalComment: input.additionalComment
                                                                    };
                                                            }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), getSelectItemDynamically(form.cancelledByResult, cancellationReasons)));
                                              }), orderStatus === 8, undefined, "Select the reason for ending trip.", undefined, undefined, undefined, form.cancelledReasonResult, undefined, "edit-order-select-style", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                        select_props: {
                                          value: form.input.cancelledReason,
                                          items: getSelectItemDynamically(form.cancelledByResult, cancellationReasons),
                                          isNoneRequired: false
                                        }
                                      })), React.createElement("div", undefined, React.createElement("label", undefined, "Addidional Comments"), React.createElement(FormTextArea.make, {
                                        input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                                return Curry._2(form.updateAdditionalComment, (function (input, value) {
                                                              return {
                                                                      cancelledBy: input.cancelledBy,
                                                                      cancelledReason: input.cancelledReason,
                                                                      additionalComment: value
                                                                    };
                                                            }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                              }), orderStatus === 8, undefined, "Enter any additional comments", undefined, undefined, undefined, form.additionalCommentResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                        textinput_props: {
                                          value: form.input.additionalComment
                                        }
                                      })))
                        }), tmp), React.createElement(ProgressModal.make, {
                      isOpen: match$2[0]
                    })), React.createElement("div", {
                  className: "footer-container"
                }, React.createElement("div", {
                      className: "c-edit-order-footer"
                    }, React.createElement(SecondaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                TAG: /* Text */0,
                                _0: "Close"
                              }, undefined, (function (_event) {
                                  return Curry._1(toggleEditOrderSidebar, undefined);
                                }), undefined, undefined, undefined, undefined, "close-button-enabled", undefined, undefined)
                        }), React.createElement(PrimaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                TAG: /* Text */0,
                                _0: "Submit"
                              }, orderStatus === 8, (function (_event) {
                                  return Curry._1(toggleSaveModal, (function (param) {
                                                return true;
                                              }));
                                }), undefined, undefined, undefined, undefined, orderStatus !== 8 ? "submit-button-enabled" : "button-disabled", undefined, undefined)
                        }))));
}

var make = CancelOrderForm;

export {
  isCancelOrderFormActive ,
  Form ,
  makeSelectComponentList ,
  getSelectItemDynamically ,
  make ,
  
}
/* react Not a pure module */
